import { Button, Grid } from '@mui/material'

export default function ActionButtons({ canSave, onSave, onCancel }) {
    return (
        <Grid container justifyContent='flex-end' mt={!canSave ? 2 : 2} gap={2}>
            <Button
                variant='contained'
                color='buttonCancel'
                onClick={onCancel}
                sx={{
                    fontWeight: 400,
                    boxShadow: 'none',
                    fontSize: '12px',
                    padding: '5px 15px',
                }}
            >
                Cancel
            </Button>
            <Button
                variant='contained'
                color='secondary'
                disabled={!canSave}
                onClick={onSave}
                sx={{
                    color: 'primary.lightest',
                    fontWeight: 400,
                    boxShadow: 'none',
                    fontSize: '12px',
                    padding: '5px 15px',
                }}
            >
                Save
            </Button>
        </Grid>
    )
}
